import { AppDispatch, logoutAction } from '@/store'
import { fetchNotificationCount } from '@/store/notification/notification.slice'
import { fetchUser, getCurrentPlanThunk, selectUser } from '@/store/user/user.slice'
import { Spin } from 'antd'
import { memo, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Outlet } from 'react-router-dom'

export default memo(function RootLayout() {
  const dispatch = useDispatch<AppDispatch>()
  const userInfo = useSelector(selectUser).userInfo
  useEffect(() => {
    dispatch(fetchUser())
    dispatch(getCurrentPlanThunk())
    dispatch(fetchNotificationCount())

    return () => {
      dispatch(logoutAction())
    }
  }, [])

  if (!userInfo) {
    return (
      <div className={'center-container '}>
        <Spin size='large' tip='Loading...' />
      </div>
    )
  }

  return <Outlet key={'RootLayout'} />
})
